import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const AddressGenerator = ({ show, handleClose, setDireccion, children }) => {
    
    const [formData, setFormData] = useState({
        tipoVia: "",
        numeroVia: "",
        apendiceVia: "",
        orientacionVia: "",
        numeroCruce: "",
        apendiceCruce: "",
        orientacionCruce: "",
        numero: "",
        complemento: "",
      });

    const tiposVia = ["CL", "CR", "CQ", "TV", "DG"];
    const apendices = ["A", "B", "AA", "BB", "CC", "DD", "EE", "FF", "GG", "HH"];
    const orientaciones = ["Sur", "Este"];
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        const direccion = Object.values(formData).filter(value => value).join(" ");
        setDireccion(direccion);
        setFormData({
            tipoVia: "",
            numeroVia: "",
            apendiceVia: "",
            orientacionVia: "",
            numeroCruce: "",
            apendiceCruce: "",
            orientacionCruce: "",
            numero: "",
            complemento: "",
        });
        handleClose();
      };
    
    return (
        <div className="modal-90w">
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="example-custom-modal-styling-title"
            >
                {children}
                <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">Direcciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor='tipoVia'>Tipo de V&iacute;a</label>
                                <select
                                    id="tipoVia"
                                    name="tipoVia"
                                    value={formData.tipoVia}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                <option value="">Seleccionar</option>
                                {tiposVia.map((tipo, index) => (
                                    <option key={index} value={tipo}>
                                    {tipo}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="numeroVia">N&uacute;mero de V&iacute;a</label>
                                <input
                                id="numeroVia"
                                type="number"
                                name="numeroVia"
                                value={formData.numeroVia}
                                onChange={handleChange}
                                className="form-control"
                                min="1"
                                max="999"
                                />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="apendiceVia">Ap&eacute;ndice V&iacute;a</label>
                                <select
                                id="apendiceVia"
                                name="apendiceVia"
                                value={formData.apendiceVia}
                                onChange={handleChange}
                                className="form-control"
                                >
                                <option value="">Seleccionar</option>
                                {apendices.map((apendice, index) => (
                                    <option key={index} value={apendice}>
                                    {apendice}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="orientacionVia">Orientaci&oacute;n V&iacute;a</label>
                                <select
                                id="orientacionVia"
                                name="orientacionVia"
                                value={formData.orientacionVia}
                                onChange={handleChange}
                                className="form-control"
                                >
                                <option value="">Seleccionar</option>
                                {orientaciones.map((orientacion, index) => (
                                    <option key={index} value={orientacion}>
                                    {orientacion}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="numeroCruce">N&uacute;mero de Cruce</label>
                                <input
                                id="numeroCruce"
                                type="number"
                                name="numeroCruce"
                                value={formData.numeroCruce}
                                onChange={handleChange}
                                className="form-control"
                                min="1"
                                max="999"
                                />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="apendiceCruce">Ap&eacute;ndice Cruce</label>
                                <select
                                id="apendiceCruce"
                                name="apendiceCruce"
                                value={formData.apendiceCruce}
                                onChange={handleChange}
                                className="form-control"
                                >
                                <option value="">Seleccionar</option>
                                {apendices.map((apendice, index) => (
                                    <option key={index} value={apendice}>
                                    {apendice}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="orientacionCruce">Orientaci&oacute;n Cruce</label>
                                <select
                                id="orientacionCruce"
                                name="orientacionCruce"
                                value={formData.orientacionCruce}
                                onChange={handleChange}
                                className="form-control"
                                >
                                <option value="">Seleccionar</option>
                                {orientaciones.map((orientacion, index) => (
                                    <option key={index} value={orientacion}>
                                    {orientacion}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label htmlFor="numero">N&uacute;mero</label>
                                <input
                                id="numero"
                                type="number"
                                name="numero"
                                value={formData.numero}
                                onChange={handleChange}
                                className="form-control"
                                min="1"
                                max="999"
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="form-group">
                                <label htmlFor="complemento">Complemento o sin nomenclatura</label>
                                <input
                                id="complemento"
                                type="text"
                                name="complemento"
                                value={formData.complemento}
                                onChange={handleChange}
                                className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                    <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                        Generar Direcci&oacute;n
                    </button>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default AddressGenerator;